import { AuthenticationService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';
import { DecryptAesClientSide, EncryptAesClientSide } from '../encryption';
import { ErrorCodes, ErrorStrings, StorageValues } from '../consts';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ModalForceCloseService } from '../services/utelize/general/modal-force-close-service';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { StorageService } from '../services/utelize/general/storage-service';

@Injectable()

export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService : AuthenticationService,
    private modalForceCloseService: ModalForceCloseService,
    private router                : Router,
    private storageService        : StorageService
  ) { }
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request)
            .pipe(catchError(err => {

              if (err?.status===401) {
                this.authenticationService.logout();
                location.reload();
              }

              if (err?.error instanceof Blob)
                return throwError(() => err);

              if (err?.status===400 &&
                  (err?.error?.error===ErrorStrings.RecipientLimitExceeded ||
                   (typeof err?.error==='string' && err.error.includes(ErrorStrings.RecipientLimitExceeded))))
                return throwError(() => err);

              if (err?.status===403) {
                let forbiddenError="";

                if (err?.error && typeof err.error==='object' && typeof err.error.error==='string')
                  forbiddenError=err.error.error;

                else if (typeof err?.error?.errorMessage==='string')
                  forbiddenError=err.error.errorMessage;

                else if (typeof err?.error==='string')
                  forbiddenError=err.error;

                return throwError(() => forbiddenError!=="" ? forbiddenError : ErrorStrings.AccessDenied);
              }
      
              //CRN_20241022 - Original code wrote by 'another', does not work and is wrong in my opinion
              //const error = err.error.message || err.statusText;
      
              //CRN_20241022 - Replacement code
              let error="";

              //CRN_20260804 - Replace recognised recoverable API errors with friendly messages
              if (err?.error?.errorCode===ErrorCodes.SignedTokenExpired)
                return throwError(() => ErrorStrings.SignedTokenExpired);

              //CRN_20260522 - Backend audit-id envelope: { error: string, auditId: number }
              if (err?.error && typeof err.error==='object' && typeof err.error.error==='string')
                error=typeof err.error.auditId==='number' ? (err.error.error+' (audit ID: '+err.error.auditId+')') : err.error.error;

              else if (typeof err?.error?.errorMessage==='string')
                error=err?.error?.errorMessage;

              else if (typeof err?.error?.message==='string')
                error=err?.error?.message;

              else if (typeof err?.error==='string')
                error=err?.error;

              else if (typeof err?.message==='string')
                error=err?.message;

              else if (typeof err?.statusText==='string')
                error=err?.statusText;
              else
                error="Error in Request, the cause cannot be determined";

              if (error.includes(ErrorStrings.SecurityTokenSessionEnd)) {
                if(!DecryptAesClientSide(this.storageService.getItem(StorageValues.encSessionEnded))) {
                  this.storageService.setItem(StorageValues.encSessionEnded, EncryptAesClientSide("true"));

                  this.authenticationService.logout();
                  this.router.navigate(['/auth/login']);
                  this.modalForceCloseService.dismissAllForced();
                }
                
                error=ErrorStrings.NoError;
              }

              //RBW_20260730 - Ignore queued missing-token errors after logout
              if (error.includes(ErrorStrings.SecurityTokenMissing) &&
                  !DecryptAesClientSide(this.storageService.getItem(StorageValues.encToken)) &&
                  !DecryptAesClientSide(this.storageService.getItem(StorageValues.encSsoToken))) {
                error=ErrorStrings.NoError;
              }

              return throwError(() => error);
            }))
  }
}
